type StringReplaceMapping = [string, string, string?]

// First element is the word to replace

// Second element is what to replace it with

// Third option element is what needs to be present in additional response items
// for the replace to occur. This helps with replacing text that has the same obfuscated value
const stringReplaceMapping: StringReplaceMapping[] = [
  ["s***", "slut", "slutt"],
  ["f***", "fuck"],
  ["f*****", "fucked"],
  ["f******", "fucking"],
  ["b****", "bitch"],
  ["s***", "shit"],
  ["c***", "cunt"],
  ["b******", "blowjob"],
  ["p****", "pussy"],
]

const processSTTResponse = (items: string[]): string => {
  let primaryResponse = items[0]

  stringReplaceMapping.forEach(([from, to, verifier]) => {
    if (!verifier || items.includes(verifier)) {
      primaryResponse = primaryResponse.replace(from, to)
    }
  })

  return primaryResponse
}

export default processSTTResponse
